import template from './template.html'

angular.module('contabilidad.polizas')
  .config(['$stateProvider', Config])

function Config ($stateProvider) {
  $stateProvider.state('contabilidad.polizas.nodeducibles', {
    url: '/nodeducibles?{fecha_inicio:date}&{fecha_fin:date}&:ID_Cliente&:ID_Moneda&:CuentaBancaria',
    template,
    data: {title: 'Póliza de Gastos No Deducibles'},
    resolve: {
      cuentasBancarias: ['$catalogos', function ($catalogos) {
        return $catalogos.get('cuentasBancarias')
      }],
      monedas: ['$catalogos', function ($catalogos) {
        return $catalogos.get('monedas')
      }],
      clientes: ['ContabilidadPolizas', function (ContabilidadPolizas) {
        return ContabilidadPolizas.obtenerClientes()
      }],

      polizas: ['noDeduciblesService', '$stateParams', function (noDeduciblesService, $stateParams) {
        var fecha_inicio = $stateParams['fecha_inicio'],
          fecha_fin = $stateParams['fecha_fin'],
          ID_Cliente = $stateParams['ID_Cliente'],
          ID_Moneda = $stateParams['ID_Moneda'],
          CuentaBancaria = $stateParams['CuentaBancaria']

        return fecha_inicio && fecha_fin && ID_Cliente && ID_Moneda && CuentaBancaria ? noDeduciblesService.obtenerInformacionGastosNoDeducibles(
          fecha_inicio,
          fecha_fin,
          ID_Cliente,
          ID_Moneda,
          CuentaBancaria,
        ) : undefined
      }],
    },
    controllerAs: '$ctrl',
    controller: Controller,
  })
}

Controller.$inject = ['polizas', 'clientes', 'monedas', 'cuentasBancarias', '$dialog', '$stateParams', '$location']

function Controller (polizas, clientes, monedas, cuentasBancarias, $dialog, $stateParams, $location) {
  var $ctrl = this

  $ctrl.data = polizas

  $ctrl.nuevoData = undefined
  if ($ctrl.data) {
    $ctrl.nuevoData = ordenarArray($ctrl.data)
  }

  $ctrl.Filtro = undefined
  $ctrl.clientes = clientes
  $ctrl.monedas = monedas
  $ctrl.cuentasBancarias = cuentasBancarias

  $ctrl.opciones = {
    fecha_inicio: $stateParams['fecha_inicio'] || new Date(),
    fecha_fin: $stateParams['fecha_fin'] || new Date(),
    ID_Cliente: $stateParams['ID_Cliente'] || undefined,
    ID_Moneda: $stateParams['ID_Moneda'] || '1',
    CuentaBancaria: $stateParams['CuentaBancaria'] || undefined,
  }

  $ctrl.obtenerInformacion = obtenerInformacion
  $ctrl.exportar = exportar

  function exportar () {
    var cliente = ''
    $ctrl.clientes.map(function (item) {
      if (item.ID_Cliente === $ctrl.opciones.ID_Cliente) {
        cliente = item.Nombre
      }
    })
    $dialog.show('contabilidad.polizas.exportar', {
      data: $ctrl.nuevoData,
      fecha_inicio: $ctrl.opciones.fecha_inicio,
      // Se agregó ésta propiedad para indicar qué es lo que se va a exportar
      config: {
        fecha_inicio: $ctrl.opciones.fecha_inicio,
        fecha_fin: $ctrl.opciones.fecha_fin,
        cliente: cliente,
        archivo: 'Gastos_No_Deducibles ' + $ctrl.opciones.fecha_inicio.toYMD(),
        tipo_poliza: 'gastosNoDeducibles',
      },
    })
  }

  function obtenerInformacion () {
    $location.search({
      fecha_inicio: $ctrl.opciones.fecha_inicio.toYMD(),
      fecha_fin: $ctrl.opciones.fecha_fin.toYMD(),
      ID_Cliente: $ctrl.opciones.ID_Cliente,
      ID_Moneda: $ctrl.opciones.ID_Moneda,
      CuentaBancaria: $ctrl.opciones.CuentaBancaria,
    })
  }

  function ordenarArray (data) {

    var nuevoData = [],
      aux = [],
      total = 0,
      total_Elementos = 0,
      referencias = [],
      Banco_Forma_Pago,
      Fecha_Movimiento,
      Banco_Referencia

    if (data.length > 0) {
      data.forEach(function (item) {
        if (referencias.indexOf(item.Banco_Referencia) === -1) {
          referencias.push(item.Banco_Referencia)
        }
      })

      referencias.forEach(function (item) {
        data.forEach(function (ele) {
          if (item === ele.Banco_Referencia) {
            aux.push(ele)
            total += ele.Importe_Pesos
            Banco_Forma_Pago = ele.Banco_Forma_Pago
            Banco_Referencia = ele.Banco_Referencia
            Fecha_Movimiento = ele.Fecha_Movimiento

          }
        })

        nuevoData.push({
          Referencia: Banco_Referencia,
          Total: total,
          Banco_Forma_Pago: Banco_Forma_Pago,
          Fecha_Movimiento: Fecha_Movimiento,
          cuentas: aux,
        })

        aux = []
        total = 0
      })
    }
    return nuevoData
  }
}




// WEBPACK FOOTER //
// ./src/contabilidad/polizas/components/nodeducibles/component.js